import React from "react";
import { FaIndustry, FaBalanceScale, FaCogs } from "react-icons/fa";

const services = [
  {
    title: "Manufacturing",
    desc: "Produksi komponen otomotif dan elektronik dengan fasilitas modern seperti Progressive Super Cutter Machine, Hydraulic Die Cutting Machine, Hot Die-Cutting Press Machine, dan Laminating Machine.",
    icon: <FaIndustry size={32} color="#2563eb" />,
  },
  {
    title: "Quality Measurement",
    desc: "Pengujian kualitas dengan standar internasional menggunakan Hardness Tester, Push Gauge, Digital Caliper, dan Steel Scale untuk memastikan ketepatan dan konsistensi produk.",
    icon: <FaBalanceScale size={32} color="#16a34a" />,
  },
  {
    title: "Automotive & Electronic Parts Supply",
    desc: "Penyediaan berbagai komponen otomotif dan elektronik, termasuk noise, vibration, cushion, offset part, dan hardness component.",
    icon: <FaCogs size={32} color="#f59e0b" />,
  },
];

const Services = () => {
  return (
    <section
      id="services"
      style={{
        padding: "4rem 2rem 2rem 2rem",
        background: "linear-gradient(135deg, #bbf7d0, #fef08a)",
      }}
    >
      {/* Judul */}
      <h2
        style={{
          textAlign: "center",
          fontSize: "2.2rem",
          fontWeight: "bold",
          color: "#111827",
          marginBottom: "2.5rem",
        }}
      >
        Our Services
      </h2>

      {/* Grid Services */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "2rem",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {services.map((service, i) => (
          <div
            key={i}
            style={{
              background: "white",
              padding: "2rem 1.5rem",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
            }}
          >
            <div style={{ marginBottom: "1rem" }}>{service.icon}</div>
            <h3
              style={{
                fontSize: "1.3rem",
                fontWeight: "bold",
                color: "#111827",
                marginBottom: "0.5rem",
              }}
            >
              {service.title}
            </h3>
            <p
              style={{
                color: "#4b5563",
                fontSize: "0.95rem",
                lineHeight: "1.6",
                textAlign: "justify",
              }}
            >
              {service.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
